import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

var _Icon;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useCallback } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Container, Icon, LanguageSwitcher } from "../../../../Common";
import { Input } from "../../../../Controls";
import { Text } from "../../../../Typography";
import { Grid } from "../../..";
import { useHeaderContext } from '../../HeaderContext';
import UserBlock from './UserBlock';
import Navigation from './Navigation';
import styles from './DropDownMenu.scss';

var DropDownMenu = function DropDownMenu(_ref) {
  var navigation = _ref.navigation,
      additionalContentSlot = _ref.additionalContentSlot,
      isOpened = _ref.isOpened,
      setIsOpened = _ref.setIsOpened,
      onClickLogin = _ref.onClickLogin,
      onClickLogout = _ref.onClickLogout,
      onClickRegister = _ref.onClickRegister,
      onSubmitSearch = _ref.onSubmitSearch,
      onActiveNavLinkClick = _ref.onActiveNavLinkClick,
      customHandleLangChange = _ref.customHandleLangChange;

  var _useTranslation = useTranslation(['headerUi']),
      t = _useTranslation.t;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      searchValue = _useState2[0],
      setSearchValue = _useState2[1];

  var _useHeaderContext = useHeaderContext(),
      user = _useHeaderContext.user;

  var handleChangeSearch = useCallback(function (e) {
    return setSearchValue(e.target.value);
  }, []);
  var handleSubmitSearch = useCallback(function (e) {
    if (onSubmitSearch) {
      onSubmitSearch(searchValue);
    }

    if (searchValue && setIsOpened) {
      setIsOpened(false);
    }

    e.preventDefault();
  }, [searchValue, onSubmitSearch, setIsOpened]);
  var isLogin = !!user;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.dropdownWrap, _defineProperty({}, styles.isOpened, isOpened))
  }, isOpened && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.fakeDropdownHeader
  }), /*#__PURE__*/React.createElement(Grid.Container, {
    className: styles.gridContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.dropdownHeader
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: isLogin ? onClickLogout : onClickRegister,
    className: styles.guestActionBtn
  }, _Icon || (_Icon = /*#__PURE__*/React.createElement(Icon, {
    name: "exit"
  })), /*#__PURE__*/React.createElement(Container, {
    paddingLeft: 0.5
  }, /*#__PURE__*/React.createElement(Text, {
    color: "label",
    size: "small"
  }, isLogin ? t('LOGOUT_BTN_TEXT') : t('REGISTER_BTN_TEXT'))))), /*#__PURE__*/React.createElement("div", {
    className: styles.dropdownContent
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(UserBlock, {
    onClickLogin: onClickLogin,
    onActiveNavLinkClick: onActiveNavLinkClick,
    className: styles.userBlock
  }), !!onSubmitSearch && /*#__PURE__*/React.createElement(Container, {
    marginBottom: 2
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmitSearch
  }, /*#__PURE__*/React.createElement(Input, {
    value: searchValue,
    label: t('SEARCH_PLACEHOLDER'),
    iconName: "search",
    onChange: handleChangeSearch,
    onClickIcon: handleSubmitSearch
  }))), /*#__PURE__*/React.createElement(Navigation, {
    navigation: navigation,
    onActiveNavLinkClick: onActiveNavLinkClick
  }), additionalContentSlot && additionalContentSlot), /*#__PURE__*/React.createElement("footer", {
    className: styles.dropdownFooter
  }, /*#__PURE__*/React.createElement(Container, {
    marginTop: 6,
    marginBottom: 4,
    className: styles.langSwitcherWrapper
  }, /*#__PURE__*/React.createElement(LanguageSwitcher, {
    customHandleLangChange: customHandleLangChange,
    isMobile: true
  })))))));
};

export default DropDownMenu;